<template>
  <RouterLink :to="to" :exact="false" v-if="$route.name">
    {{ mode === 'short' ? this.toLang.toUpperCase() : $t(`langs.${this.toLang}`) }}
  </RouterLink>
</template>

<script>
export default {
  name: 'LangSwitchLink',
  props: {
    mode: {
      type: String,
      default: 'short',
      validator: (value) => ['long', 'short'].includes(value),
    },
  },
  data() {
    return {
      langs: ['fr', 'en'],
    }
  },
  computed: {
    storeObjectKey() {
      if (this.$route.name.includes('category')) return 'categories'
      if (this.$route.name.includes('activity')) return 'activities'
      return null
    },
    to() {
      return {
        name:
          this.toLang !== this.$defaultLang
            ? `${this.$route.name}:${this.toLang}`
            : this.$route.name.substring(0, this.$route.name.indexOf(':')),
        params: this.storeObjectKey
          ? this.getTranslatedParams(this.$route.params)
          : this.$route.params,
        query: this.storeObjectKey
          ? this.getTranslatedParams(this.$route.query)
          : this.$route.query,
      }
    },
    toLang() {
      const locale = this.$i18n.locale.value || this.$i18n.locale
      return this.langs.find((lang) => lang !== locale)
    },
  },
  methods: {
    getTranslatedParams(paramType) {
      return Object.entries(paramType).reduce((newParamObj, [paramKey, paramValue]) => {
        if (paramKey === 'pathMatch') return { [paramKey]: paramValue }
        return { ...newParamObj, ...this.paramTranslator(paramKey, paramValue) }
      }, {})
    },
    paramTranslator(paramKey, paramValue) {
      const elementId = this.$store.getters[`${this.storeObjectKey}SlugMap`][paramValue]
      const { slugs = {} } = this.$beet[`${this.storeObjectKey}`][elementId] || {}
      return elementId ? { [paramKey]: slugs[this.toLang] } : { [paramKey]: paramValue }
    },
  },
}
</script>
